import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';

@Component({
  selector: 'admins-dialog',
  templateUrl: 'admins.dialog.html',
  styleUrls: ['admins.dialog.css'],
})

export class AdminsDialogComponent implements OnDestroy{
  addAdminForm: FormGroup;

  public type = '';

  controllers = [];
  public clients = [];

  public company_name = 'Client not set';
  public selClient;
  error = '';
  passwordReset = false;
  resetInProgress = false;
  timerSub = null;
  saveInProgress = false;

  constructor(public dialogRef: MatDialogRef<AdminsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient, private auth: AuthenticationService, private urlHelper: UrlHelper) {

    if (data.user) {
      this.addAdminForm = new FormGroup({
        first_name: new FormControl(data.user.attributes.first_name, Validators.required),
        last_name: new FormControl(data.user.attributes.last_name, Validators.required),
        email: new FormControl({value: data.user.attributes.email, disabled: true}),
        phone: new FormControl(data.user.attributes.phone, Validators.required),
        active: new FormControl(data.user.attributes.active, Validators.required)
      });
    } else {
      this.addAdminForm = new FormGroup({
        first_name: new FormControl('', Validators.required),
        last_name: new FormControl('', Validators.required),
        email: new FormControl('', Validators.required),
        phone: new FormControl('', Validators.required),
        active: new FormControl(1, Validators.required)
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCloseConfirm() {
    this.dialogRef.close('Confirm');
  }

  onCloseCancel() {
    this.dialogRef.close('Cancel');
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  onSubmit({value, valid}) {
    if (valid) {
      this.saveInProgress = true;
      this.save(value).subscribe((res) => {
        this.saveInProgress = false;
        if (this.data.user) {
          if (res['data'].hasOwnProperty('id') && res['data'].id === this.data.user.id) {
            this.onCloseConfirm();
          }
        } else {
          this.onCloseConfirm();
        }
      }, (err) => {
        // TO-DO
        this.saveInProgress = false;

        if (err.hasOwnProperty('error') && err.error.hasOwnProperty('errors') && Array.isArray(err.error.errors)) {
          this.error = err.error.errors[0].detail;
        } else {
          this.error = 'An error occurred';
        }
        // do nothing
      }, () => {
        this.saveInProgress = false;
      });
    }
  }

  resetPassword() {
    this.resetInProgress = true;

    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.auth.forgotPassword(this.data.user.attributes.email).subscribe((res) => {
      this.passwordReset = true;
      this.resetInProgress = false;

      this.timerSub = Observable.of(true).delay(5000).subscribe(() => {
        this.passwordReset = false;
      });
    });
  }

  private save(data): Observable<any> {
    const body = {
      data: {
        type: 'Admins',
        attributes: {
          first_name: data.first_name,
          last_name: data.last_name,
          phone: data.phone,
          active: data.active === 1
        }
      }
    };

    if (this.data.user) {
      body.data['id'] = this.data.user.id;
      return this.http.put(`${this.urlHelper.getPrefix()}/admins/${this.data.user.id}`, body);
    } else {
      body.data.attributes['email'] = data.email;
      return this.http.post(`${this.urlHelper.getPrefix()}/admins`, body);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admins/admins.dialog.component.ts